module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/15G2npA/tc-custom/9781454936756.jpg?1700958170460",
      "alt": "This image is the cover for the book Healing Power of Plants"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Healing Power of Plants\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("From an award–winning horticulturist, a guide to how to use houseplants to promote health and wellness.")]), _c('br'), _c('br'), _vm._v("Plants don’t only beautify your home —they promote healing too. For example, the luscious scent of lavender aids in a good night’s sleep, while the kentia palm controls humidity levels that increase mold and mildew. This lushly illustrated guide explains the properties of the most beneficial species, from plants that lower stress and provide a breath of fresh air to ones that bring joy, boost brainpower, and help you communicate. It explains how to choose the right plants for your specific needs, where to place them in your home and office, which ones are pet friendly, and how to make sure they thrive—so you will too."), _c('br'), _c('br'), _vm._v("And if you don’t have a green thumb, you’ll find a guide to 10 easygoing plants that are perfect for starting your indoor garden."), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Fran Bailey\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Award-winning horticulturist Fran Bailey studied at the Welsh College of Horticulture before moving to London to become a florist. Later she opened her first shop, the Fresh Flower Company, which she runs. Fran has written two other houseplant books in collaboration with the Royal Horticultural Society. Visit forest.london or follow @forest_london on Instagram.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0